import { ref, watch } from "vue";

export const printAfterAccept = ref(true);
if (localStorage.hasOwnProperty('PRINT_AFTER_ACCEPT')) {
    printAfterAccept.value = localStorage.getItem('PRINT_AFTER_ACCEPT') === 'true';
}
watch(printAfterAccept, (newVal: boolean) => {
    localStorage.setItem('PRINT_AFTER_ACCEPT', newVal.toString());
});

export const copies = ref(1);
if (localStorage.hasOwnProperty('COPIES_NUMBER')) {
    copies.value = Number(localStorage.getItem('COPIES_NUMBER')) || 1;
}

watch(copies, (newVal: number) => {
    localStorage.setItem('COPIES_NUMBER', newVal.toString());
});